

import { Entity } from '../entity';
import { FiltersNumberMethod } from '../../utilities/filters.number.utility';
import { FiltersRelativeDateMethod } from '../../utilities/filters.relative.date.utility';
import { LeadSystemStage } from './lead.stage';
import * as Enumerable from 'linq';

export interface LeadViewLookups {
    // Lead Filters
    tags?: Entity[];
    owner?: Entity[];
    company?: Entity[];
    source?: Entity[];
    stage?: LeadSystemStage[];
    jobType?: Entity[];
    zones?: Entity[];
}

export interface LeadViewFilters extends LeadViewLookups {
    _id?: string;
    total?: number;

    // Multi - Need to check data inside
    search?: string;

    amount?: FiltersNumberMethod;
    createdAt?: FiltersRelativeDateMethod;
    expectedClose?: FiltersRelativeDateMethod;
    lastActivity?: FiltersRelativeDateMethod;

}

export function effectiveLeadViewFilters(view: LeadViewFilters, refinements: LeadViewFilters) {

    const effective: { [k in keyof LeadViewFilters] } = {} as LeadViewFilters;
    const keys = Object.keys(new LeadViewFiltersClass())

    Enumerable.from(keys)
        .forEach(key => {

            const refinement = refinements[key];
            const viewValue = view[key];

            if (Array.isArray(refinement) || Array.isArray(viewValue)) {
                effective[key] = refinement?.length
                    ? refinement
                    : viewValue;
            } else {
                effective[key] = refinement
                    ? refinement
                    : view[key];
            }

            if (effective[key] == null || Object.keys(effective[key])?.length == 0) {
                delete effective[key];
            }
        });

    return effective;

}

export function isLeadViewFiltersRefined(refinements: LeadViewFilters): boolean {

    if (!refinements) return false;
    if (refinements.search && (refinements.search !== null || refinements.search === '')) return true;

    if (refinements?.owner?.length) return true;
    if (refinements?.tags?.length) return true;
    if (refinements?.company?.length) return true;
    if (refinements?.source?.length) return true;
    if (refinements?.stage?.length) return true;
    if (refinements?.jobType?.length) return true;

    if (refinements.expectedClose) return true;
    if (refinements.lastActivity) return true;
    if (refinements.createdAt) return true;
    if (refinements.amount) return true;

    return false;
}


class LeadViewFiltersClass implements LeadViewFilters {
    _id = null;

    // Multi - Need to check data inside
    search?: string = null;

    // Job Filters
    tags?: Entity[] = [];
    company?: Entity[] = [];
    owner?: Entity[] = [];
    source?: Entity[] = [];
    stage?: LeadSystemStage[] = [];
    jobType?: Entity[] = [];
    zones?: Entity[] = [];

    amount?: FiltersNumberMethod = null;
    expectedClose?: FiltersRelativeDateMethod = null;
    createdAt?: FiltersRelativeDateMethod = null;
    lastActivity?: FiltersRelativeDateMethod = null;
}
